import { render, staticRenderFns } from "./StcvD_ItemsFinish.vue?vue&type=template&id=1622c13b"
import script from "./StcvD_ItemsFinish.vue?vue&type=script&lang=js"
export * from "./StcvD_ItemsFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports